import type { TweetType } from '@/types/api';

interface TweetBadgesProps {
  types: TweetType[];
}

export function TweetBadges({ types }: TweetBadgesProps) {
  if (types.length === 0) return null;

  return (
    <div className="tweet-badges flex gap-1.5">
      {types.map((type) => {
        const name = type === 'LikesModule' ? '点赞' : '收藏';
        return (
          <span
            key={type}
            className={`tweet-badge px-2 py-0.5 bg-bg-tertiary rounded text-text-muted text-xs ${
              type === 'LikesModule' ? 'text-like' : 'text-accent'
            }`}
          >
            {name}
          </span>
        );
      })}
    </div>
  );
}
